import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function submitAssessment(payload) {
  const { data } = await api.post("/assessments", payload);
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function exchangeSession(session_id) {
  const { data } = await api.post("/auth/session", { session_id });
  return data;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

const SSE_DONE = "[DONE]";

// Parses a single SSE "data:" block. Returns true when the stream is complete.
function processSSEBlock(block, { onSession, onDelta, onError }) {
  const line = block.trim();
  if (!line.startsWith("data:")) return false;
  const payload = line.slice(5).trim();
  if (payload === SSE_DONE) return true;
  try {
    const obj = JSON.parse(payload);
    if (obj.session_id) onSession?.(obj.session_id);
    if (obj.delta) onDelta?.(obj.delta);
    if (obj.error) onError?.(obj.error);
  } catch (error) {
    console.warn("streamChat: could not parse SSE payload", payload, error);
  }
  return false;
}

// Streaming chat helper (SSE)
export async function streamChat({ session_id, message, onDelta, onSession, onDone, onError }) {
  try {
    const res = await fetch(`${API}/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id, message }),
    });
    if (!res.ok || !res.body) throw new Error("Stream failed");

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const blocks = buffer.split("\n\n");
      buffer = blocks.pop() || "";
      for (const block of blocks) {
        if (processSSEBlock(block, { onSession, onDelta, onError })) {
          onDone?.();
          return;
        }
      }
    }
    onDone?.();
  } catch (e) {
    onError?.(e.message);
  }
}
